import { LuBot } from 'react-icons/lu';
import ResourceListPage from '../../../components/resource-list-page';
import { SUB_AGENT_BASE } from '../../../consts/agent-nav-config';
import { useSubAgentList } from '../../../helpers/hooks/sub-agent-hook';
import { deletePromptConfigTool } from '../../../services/prompt-ai';
import SubAgentCreateDialog from '../sub-agent-create';

export default function AgentSubAgents() {
    const list = useSubAgentList();
    return (
        <ResourceListPage
            key={list.appId}
            title="Sub-Agents"
            singular="Sub-agent"
            subtitle="Create specialized agents the main agent can delegate tasks to."
            emptyDescription="Add a sub-agent to handle a specialized task with its own instructions and tools."
            icon={LuBot}
            list={list}
            basePath={SUB_AGENT_BASE}
            deleteItem={deletePromptConfigTool}
            renderEditor={({ item, ...callbacks }) => <SubAgentCreateDialog subAgentId={item.id} {...callbacks} />}
        />
    );
}
